import { Button } from "components/Button/Button";
import Link from "components/Button/Link";
import { Input, TextArea } from "components/Form";
import TextEditor from "components/TextEditor/TextEditor";
import { ContentState, convertFromHTML, EditorState } from "draft-js";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import htmlToDraft from "html-to-draftjs";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { getPostbyId, updatePost } from "services/blogs/blogs";
import { editGSChapter, getGSChapterById } from "services/gsfreeresources";
import { objectTypeChecker, rawToHtmlConverter, wrapImagesWithFigure } from "utils";
import { addPost, getBlogCategories } from "services/blogs/blogs";
import { encryptData } from "config/config";
import useCookie from "hooks/useCookie";
import { Avatar } from "@mui/material";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import PostTextEditor from "components/TextEditor/PostTextEditor";
import JodTextEditor from "components/TextEditor/JodTextEditor";
const usertypeid = localStorage.getItem("roleid")



export default function UpdatePost() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [data, setData] = useState({});
    const [errorField, setErrorField] = useState({});
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [file, setFile] = useState("");
    const { cookies } = useCookie();



    const handleToggle = (field) => {
        setData((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };
    const fetchData = async () => {
        showLoader();
        try {
            const res = await getPostbyId({ id });
            hideLoader();

            if (res.code === 200) {
                const post = res.data;

                const chapterContent = post.description?.trim()
                    ? post.description
                    : '<p style="font-weight: 600; font-size: 18px; text-align: center; color: red;">No Content Available</p>';

                const selectedCategoryIds = post.categories?.map(cat => cat.categoryId) || [];

                setData(prev => ({
                    ...prev,
                    title: post.title,
                    slug: post.slug,
                    shortdescription: post.shortdescription,
                    allowComment: post.comments,
                    setFeatured: post.isfeatured,
                    tags: post.tags,
                    image: post.poster, // ✅ used in Avatar src
                    posterimage: post.image,
                    selectedCategories: selectedCategoryIds,
                    chaptercontent: chapterContent,
                    content1: chapterContent,
                    content: chapterContent
                }));
            } else {
                toast.error(res.message || "Something went wrong");
            }
        } catch (err) {
            hideLoader();
            toast.error(err?.response?.data?.message || err.message || "Error occurred");
        }
    };



    const [categoryData, setcategoryData] = useState([]);

    const blockcategories = async () => {
        try {
            showLoader();
            const res = await getBlogCategories(); // your API function
            hideLoader();
            if (res.code === 200) {
                // Convert the response to match UI expectations
                const formatted = res.data.blogCategories.map((parent) => ({
                    name: parent.title,
                    children: parent.subcategories.map((child) => ({
                        id: child.categoryid,
                        name: child.title,
                    })),
                }));
                setcategoryData(formatted);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            hideLoader();
            toast.error(err?.response?.data?.message || err.message);
        }
    };


    useEffect(() => {
        blockcategories();
    }, []); // 👈 Runs only once

    const handleCategoryToggle = (id) => {
        const selected = data.selectedCategories || [];
        const updated = selected.includes(id)
            ? selected.filter((catId) => catId !== id)
            : [...selected, id];
        setData({ ...data, selectedCategories: updated });
    };

    useEffect(() => {
        if (data.chaptercontent) {
            const blocksFromHTML = data.chaptercontent;
            if (blocksFromHTML) {
                // const { contentBlocks, entityMap } = blocksFromHTML;
                // const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                setData({ ...data, content: data.chaptercontent });
            }
        }
    }, [data.chaptercontent]);

    // Fetch data when `selectedId` changes
    useEffect(() => {
        fetchData();
    }, []);



    // ***************************************** Form validation ********************************************************
    const handleValidation = () => {
        let isError = false;
        const newErrorField = {};


        if (!data.title) {
            newErrorField.title = "Please Enter title";
            isError = true;
        } else {
            newErrorField.title = "";
        }

        const slug = data.slug || "";
        const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

        if (!slug) {
            newErrorField.slug = "Please enter a URL slug";
            isError = true;
        }
        else {
            // Additional length check (recommended)
            if (slug.length > 50) {
                newErrorField.slug = "Slug must be 50 characters or less";
                isError = true;
            }
            // Check for leading/trailing hyphens
            else if (slug.startsWith('-') || slug.endsWith('-')) {
                newErrorField.slug = "Slug cannot start or end with a hyphen";
                isError = true;
            }
            // Check for consecutive hyphens
            else if (slug.includes('--')) {
                newErrorField.slug = "Slug cannot contain consecutive hyphens";
                isError = true;
            }
            // Final regex validation
            else if (!slugRegex.test(slug)) {
                newErrorField.slug = "Slug must contain only lowercase letters, numbers, and single hyphens between words";
                isError = true;
            }
            else {
                newErrorField.slug = ""; // Clear error if valid
            }
        }


        if (data.shortdescription.length < 100) {
            newErrorField.shortdescription = "Short Description should be atleast 100 characters";
            isError = true;
        }

        setErrorField(newErrorField);
        return !isError;
    };

    // ***************************************** Add Chapter ********************************************************
    const handleUpdate = async () => {
        try {
            if (handleValidation()) {

                const blogDesc = data.content;

                const formData = new FormData();
                if (file) {
                    formData.append("image", file);  // ✅ only append if it's a new File object
                }
                formData.append("title", data.title);
                formData.append("slug", data.slug);
                formData.append("shortdescription", data.shortdescription);
                formData.append("tags", data.tags);
                formData.append("isfeatured", Boolean(data.setFeatured));
                formData.append("comments", Boolean(data.allowComment));

                // ✅ Exclude 'content' and inject only blogDesc
                const { content, ...sanitizedData } = data;

                formData.append(
                    "reqData",
                    encryptData({
                        ...sanitizedData,
                        postid: id,
                        isfeatured: Boolean(data.setFeatured),
                        comments: Boolean(data.allowComment),
                        categoryIds: data.selectedCategories,
                        description: blogDesc, // converted HTML
                        access_token: cookies,
                    })
                );


                const res = await updatePost(formData);

                if (res.code === 200) {
                    navigate(-1);
                    setData({});
                    toast.success(res.message);
                } else {
                    toast.error(res.message);
                }
            } else {
                toast.error("Please fill all the fields");
            }
        } catch (e) {
            toast.error("Failed to Update Chapter");
        }
    };

    const handleUpdateApprove = async () => {
        try {
            // if (handleValidation()) {

            const blogDesc = data.content;

            const formData = new FormData();
            if (file) {
                formData.append("image", file);  // ✅ only append if it's a new File object
            }
            formData.append("title", data.title);
            formData.append("shortdescription", data.shortdescription);
            formData.append("tags", data.tags);
            formData.append("setFeatured", Boolean(data.setFeatured));
            formData.append("allowComment", Boolean(data.allowComment));

            // ✅ Exclude 'content' and inject only blogDesc
            const { content, ...sanitizedData } = data;

            formData.append(
                "reqData",
                encryptData({
                    ...sanitizedData,
                    postid: id,
                    categoryIds: data.selectedCategories,
                    isfeatured: Boolean(data.setFeatured),
                    comments: Boolean(data.allowComment),
                    description: blogDesc, // converted HTML
                    access_token: cookies,
                    status: "Approval Pending"
                })
            );


            const res = await updatePost(formData);

            if (res.code === 200) {
                navigate(-1);
                setData({});
                toast.success(res.message);
            } else {
                toast.error(res.message);
            }
            // }
        } catch (e) {
            toast.error("Failed to Update Chapter");
        }
    };
    const handleUpdatePublish = async () => {
        try {
            // if (handleValidation()) {

            const blogDesc = data.content;

            const formData = new FormData();
            if (file) {
                formData.append("image", file);  // ✅ only append if it's a new File object
            }
            formData.append("title", data.title);
            formData.append("shortdescription", data.shortdescription);
            formData.append("tags", data.tags);
            formData.append("setFeatured", Boolean(data.setFeatured));
            formData.append("allowComment", Boolean(data.allowComment));

            // ✅ Exclude 'content' and inject only blogDesc
            const { content, ...sanitizedData } = data;

            formData.append(
                "reqData",
                encryptData({
                    ...sanitizedData,
                    postid: id,
                    categoryIds: data.selectedCategories,
                    isfeatured: Boolean(data.setFeatured),
                    comments: Boolean(data.allowComment),
                    description: blogDesc, // converted HTML
                    access_token: cookies,
                    status: "Approved"
                })
            );


            const res = await updatePost(formData);

            if (res.code === 200) {
                navigate(-1);
                setData({});
                toast.success(res.message);
            } else {
                toast.error(res.message);
            }
            // }
        } catch (e) {
            toast.error("Failed to Update Chapter");
        }
    };

    const imageChangeHandler = ({ target }) => {
        const { type } = target.files[0];
        if (
            type === "image/webp" ||
            type === "image/png" ||
            type === "image/jpg" ||
            type === "image/jpeg"
        ) {
            setFile(target.files[0]);
        } else {
            toast.error("Please upload only jpeg,jpg and png image");
        }
    };

    return (
        <>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="search_wrap"></div>
                            <h4 className="Title">
                                <Link to={-1}>
                                    <i className="fa fa-arrow-left"></i>
                                </Link>
                                Update Post
                            </h4>
                        </div>
                        <div className="row mt-1">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                                <div className="form-group row mt-1">
                                    <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                                        <div className="row">
                                            <div
                                                className={`col-sm-12 col-form-label banner-upload-image p-0 ${!file && errorField.file ? "is-invalid" : ""
                                                    }`}
                                            >
                                                <Avatar
                                                    variant="square"
                                                    sx={{
                                                        width: "100%",
                                                        height: 300,
                                                        img: { width: "auto" },
                                                    }}
                                                    role="button"
                                                    src={file ? URL.createObjectURL(file) : data.image || undefined}
                                                    onClick={() => document.getElementById("upload-file").click()}
                                                >
                                                    {!file && !data.poster && (
                                                        <ViewCarouselIcon sx={{ fontSize: 60 }} />
                                                    )}
                                                </Avatar>



                                                {/* Error message below the Avatar */}
                                                {!file && errorField.file && (
                                                    <div className="invalid-feedback d-block">
                                                        {errorField?.fileMessage || "Please upload a valid image."}
                                                    </div>
                                                )}

                                                <Input
                                                    type="file"
                                                    id="upload-file"
                                                    hidden
                                                    onChange={imageChangeHandler}
                                                    accept="image/png, image/jpeg, image/jpg, image/webp"
                                                    {...submitButtonElement}
                                                />
                                            </div>

                                            <div className="col-sm-12 col-form-label">
                                                <Input
                                                    type="text"
                                                    name="title"
                                                    className={"form-control"}
                                                    placeholder="Enter Title Name"
                                                    value={data.title}
                                                    onChange={(e) => {
                                                        const { name, value } = e.target;
                                                        setData({ ...data, [name]: value });
                                                    }}
                                                    error={errorField.title}
                                                    label={"Title"}
                                                    required
                                                />
                                            </div>
                                            <div className="col-sm-12 col-form-label">
                                                <Input
                                                    type="text"
                                                    name="slug"
                                                    className={"form-control"}
                                                    placeholder="Enter URL Slug"
                                                    value={data.slug}
                                                    onChange={(e) => {
                                                        const { name, value } = e.target;
                                                        setData({ ...data, [name]: value });
                                                    }}

                                                    label={"Slug"}
                                                    required
                                                />
                                                {errorField.slug && (
                                                    <div className="text-danger" style={{ fontSize: "0.875em", color: "#dc3545" }}>
                                                        {errorField.slug}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-sm-12 col-form-label position-relative">
                                                <label className="form-label">Short Description</label>
                                                <TextArea
                                                    name="shortdescription"
                                                    className="form-control"
                                                    placeholder="Enter Short Description"
                                                    value={data.shortdescription}
                                                    rows={2}
                                                    maxLength={150}
                                                    onChange={(e) => {
                                                        const { name, value } = e.target;
                                                        setData({ ...data, [name]: value });
                                                        setErrorField({ ...errorField, [name]: "" });
                                                    }}

                                                    required

                                                />
                                                {errorField.shortdescription && (
                                                    <div className="text-danger" style={{ fontSize: "0.875em", color: "#dc3545" }}>
                                                        {errorField.shortdescription}
                                                    </div>
                                                )}


                                                {/* Character count display */}
                                                <div
                                                    style={{
                                                        position: errorField.shortdescription ? "absolute" : "static",
                                                        bottom: "4px",
                                                        right: "10px",
                                                        fontSize: "12px",
                                                        color: "#666",
                                                        float: "right",
                                                    }}
                                                >
                                                    {(data.shortdescription || "").length}/150
                                                </div>
                                            </div>


                                            <div className="col-sm-12 col-form-label">
                                                <label className="form-label">Categories</label>
                                                <div className="category-container">
                                                    {categoryData.map((parent, i) => (
                                                        <div className="category-group" key={i}>
                                                            <div className="parent-name">{parent.name}</div>
                                                            <div className="child-list">
                                                                {parent.children.map((child, j) => (
                                                                    <label key={j} className="checkbox-item">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={data.selectedCategories?.includes(child.id)}
                                                                            onChange={() => handleCategoryToggle(child.id)}
                                                                        />

                                                                        <span>{child.name}</span>
                                                                    </label>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-form-label">
                                                <Input
                                                    type="text"
                                                    name="tags"
                                                    className={"form-control"}
                                                    placeholder="Enter Tags"
                                                    value={data.tags}
                                                    onChange={(e) => {
                                                        const { name, value } = e.target;
                                                        setData({ ...data, [name]: value });
                                                    }}
                                                    error={errorField.tags}
                                                    label={"Tags"}
                                                    required
                                                />
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-auto">
                                                    <label className="checkbox-item horizontal-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={data.setFeatured}
                                                            onChange={() => handleToggle('setFeatured')}
                                                        />
                                                        <span>Set Featured</span>
                                                    </label>
                                                </div>
                                                <div className="col-auto">
                                                    <label className="checkbox-item horizontal-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={data.allowComment}
                                                            onChange={() => handleToggle('allowComment')}
                                                        />
                                                        <span>Allow Comment</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-form-label">
                                                {/* <PostTextEditor
                                                    value={data.content || ""} // Default to empty string
                                                    name="content"
                                                    style={`demo-editor3 text-editor-section2 ${errorField.content && "is-invalid"}`}
                                                    onChange={(value) =>
                                                        setData({ ...data, content: value })
                                                    }
                                                    label={"Content"}
                                                    error={errorField.content}
                                                    required
                                                    {...submitButtonElement}
                                                /> */}
                                                <label >Blog Description<span className="text-danger">*</span></label>
                                                <JodTextEditor
                                                    value={data.content || ""}
                                                    onChange={(value) => setData({ ...data, content: value })}
                                                />
                                                {errorField.content && (
                                                    <small className="text-danger">{errorField.content}</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mt-4">
                                    <Button className="mx-2" to={-1}>
                                        Cancel
                                    </Button>
                                    <Button type="acl" role={413006} className="mx-2" onClick={handleUpdate} {...submitButtonElement}>
                                        Update
                                    </Button>
                                    <Button type="acl" role={413004}
                                        className="mx-2" onClick={handleUpdateApprove} {...submitButtonElement}>
                                        Update & Approval Pending
                                    </Button>

                                    <Button
                                        type="acl" role={413005}
                                        className="mx-2" onClick={handleUpdatePublish} {...submitButtonElement}>
                                        Update & Publish
                                    </Button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
